import request from '../utils/csrf-superagent'; // enhanced superagent to handle jwt-csrf tokens
import config from '../config';
import actions from '../actions/actions';
import currencyActions from '../actions/currency';
import confirmBrandActions from '../actions/confirmBrand';

function getSiteDetails(store, action) {
    const countryCode = action.payload.countryCode;
    request.get(`/${config.url_prefix}/api/getSiteDetails?countryCode=${countryCode}`)
        .end((error, response) => {
            if (error) {
                store.dispatch(currencyActions.currencyServiceError('ipmob.internal.server.error'));
            } else {
                try {
                    const res = JSON.parse(response.text);
                    store.dispatch(currencyActions.getSupportedCurrenciesSuccess(res.currencies));
                    store.dispatch(confirmBrandActions.confirmBrand(res));
                } catch (exp) {
                    store.dispatch(currencyActions.currencyServiceError('ipmob.error.process.request'));
                }
            }
            store.dispatch(actions.enableLoadOverLay(false));
        });
}

export default getSiteDetails;
